import type { LoaderFunctionArgs } from "react-router";

import { SECTIONS } from "@/constants";
import { OrganizationsService } from "@/services/OrganizationsService";
import store from "@/store";
import { setOrganizationUsers } from "@/store/v2/organizationUsers/organizationUsersSlice";
import { initialState } from "@/store/v2/queries/initialState";
import { waitForAuthReady } from "@/utils/waitForAuthReady";

export async function organizationUsersLoader({ params }: LoaderFunctionArgs) {
  return waitForAuthReady(async () => {
    const organizationId = params.organizationId;

    if (!organizationId) {
      throw new Response("Not Found", { status: 404 });
    }

    const query = initialState[SECTIONS.ORGANIZATION_USERS];

    const {
      resp: usersResp,
      status: usersStatus,
      err: usersErr,
    } = await OrganizationsService.getUsers(+organizationId, query);
    const { data: users = [], count = 0 } = usersResp || {};

    store.dispatch(
      setOrganizationUsers({
        organizationId: +organizationId,
        data: users,
        count: count,
        status: usersStatus,
        err: usersErr,
        noResults: users.length === 0,
      }),
    );

    return { users };
  });
}
